export const getApiRoute = (path: string): string => `/api/${path}`;
